export enum DocumentosRotasEnum {
  ALTERACOESVTS = 'meurh_solicitacoesalteracoesvts_documentos_',
  SALARIOSOBDEMANDA = 'meurh_solicitacoessalariossobdemanda_documentos_',
  ALTERACOESENDERECOS = 'meurh_solicitacoesalteracoesenderecos_documentos_',
  FALTAS = 'meurh_solicitacoesfaltas_documentos_',
  ADMISSAO = 'meurh_solicitacoesadmissoes_documentos_',
  AFASTAMENTO = 'meurh_solicitacoesafastamentos_documentos_',

}
